import axios from "axios";
export default {
  state: {

  },
  getters: {

  },
  mutations: {

  },
  actions: {
    async loadUserStatistics(){
      return await axios.get(`/superadmin/user-statistics`)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    }
  },
};
